import EventType from 'models/EventType';
import Base from 'models/Base';
import { toEntityList } from 'models/BaseList';

import {
  EVENT_TYPE_ASYNC_START,
  EVENT_TYPE_ASYNC_FAIL,
  EVENT_TYPE_ASYNC_SUCCESS,
  EVENT_TYPE_LIST_ASYNC_SUCCESS,
} from 'actions/eventType';

const initialState = new Base({
  loading: false,
  errorMessage: '',
  data: new EventType(),
  list: toEntityList([], EventType),
});

const actionsMap = {
  [EVENT_TYPE_ASYNC_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: '',
    });
  },
  [EVENT_TYPE_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new EventType(action.data),
    });
  },
  [EVENT_TYPE_LIST_ASYNC_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      list: toEntityList(action.data, EventType),
    });
  },
  [EVENT_TYPE_ASYNC_FAIL]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.errorMessage,
    });
  },
};

export default function eventType(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
